import React, { useState, useRef, useImperativeHandle, forwardRef} from 'react'
import { LuckyGrid } from '@lucky-canvas/react'

import img1 from '../images/九宫格未选中态/1.png';
import img2 from '../images/九宫格未选中态/2.png';
import img3 from '../images/九宫格未选中态/3.png';
import img4 from '../images/九宫格未选中态/4.png';
import img5 from '../images/九宫格未选中态/5.png';
import img6 from '../images/九宫格未选中态/6.png';
import img7 from '../images/九宫格未选中态/7.png';
import img8 from '../images/九宫格未选中态/8.png';


import imgActive1 from '../images/九宫格选中态/1.png';
import imgActive2 from '../images/九宫格选中态/2.png';
import imgActive3 from '../images/九宫格选中态/3.png';
import imgActive4 from '../images/九宫格选中态/4.png';
import imgActive5 from '../images/九宫格选中态/5.png';
import imgActive6 from '../images/九宫格选中态/6.png';
import imgActive7 from '../images/九宫格选中态/7.png';
import imgActive8 from '../images/九宫格选中态/8.png';

export default forwardRef( ( props, ref) => {

  const [prizes] = useState([
    { x: 0, 
      y: 0 ,
      index: 0,
      num: 5,
      background: 'rgb(0,0,0,0)', 
      imgs: [{
      src: img1,
      width: '100%',
      height: '100%',
      activeSrc: imgActive1,
    }] },
    { x: 1, y: 0 ,index:1,
      num: 99999,
      background: 'rgb(0,0,0,0)', imgs: [{
      src: img2,
      
      width: '100%',
      height: '100%',
      activeSrc: imgActive2,
    }]  },
    { x: 2, y: 0, index:2,
      num: 3,
       background: 'rgb(0,0,0,0)', imgs: [{
      src: img3,
      width: '100%',
      height: '100%',
      activeSrc: imgActive3,
    }]  },
    { x: 2, y: 1 ,index:3,
      num: 93,
       background: 'rgb(0,0,0,0)', imgs: [{
      src: img4,
      width: '100%',
      height: '100%',
      activeSrc: imgActive4,
    }]  },
    { x: 2, y: 2 ,index:4,
      num: 10,
       background: 'rgb(0,0,0,0)', imgs: [{
      src: img5,
      width: '100%',
      height: '100%',
      activeSrc: imgActive5,
    }]  },
    { x: 1, y: 2 ,index:5,
      num: 372,
       background: 'rgb(0,0,0,0)', imgs: [{
      src: img6,

      width: '100%',
      height: '100%',
      activeSrc: imgActive6,
    }]  },
    { x: 0, y: 2 ,index:6, 
      num: 15,
      background: 'rgb(0,0,0,0)', imgs: [{
      src: img7,
     
      width: '100%',
      height: '100%',
      activeSrc: imgActive7,
    }]  },
    { 
      x: 0, 
      y: 1 ,
      num: 31,
      index:7, 
      background: 'rgb(0,0,0,0)',
      imgs: [{
      src: img8,
      width: '100%',
      height: '100%',
      activeSrc: imgActive8,
    }]  }
  ])


  const myLucky = useRef()
  const onStart = (newVal) => {

      myLucky.current.play()
      setTimeout(() => {
        myLucky.current.stop(newVal)
      }, 500)
  }
  useImperativeHandle(ref, () => ({
    onStart: (newVal ) => {
      onStart(newVal)
        // setVisible(true);
      }
   }));
   


  return (
    <LuckyGrid
      ref={myLucky}
      width = '67.6vw'
      height= '65.6vw'
      blocks = {[
        { padding: '7px', background: 'rgb(0,0,0,0)' }
      ]}
      prizes ={ prizes }
      buttons ={ [

      ]} 
      activeStyle= {{
        background: 'rgba(0,0,0,0)',
      }}
      defaultStyle ={ {
        // margin: 'auto',
        borderRadius: '0px',
        background: 'red'
      }}
  
      // onStart={() => { // 点击抽奖按钮会触发star回调
      

      // }}
      
      onEnd={prize => { // 抽奖结束会触发end回调
        props.onEnd(prize.num)
      }}
    />  )
})


// WEBPACK FOOTER //
// ./src/views/activity_41/components/lucky.js